import React, { FC, ReactNode } from 'react'
import { IconS24SolarPanel48 } from '@is24/cosma-ui-icons'

export const PlacementTypeStepIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container horizontal-center margin-bottom-xl'>
      <IconS24SolarPanel48 width={128} height={128} viewBox='0 0 48 48' />
    </div>
  )
}
